import React from "react";

import Select from "../index";

export default function Payroll(props) {
  const items = ["AUTHORISED", "DRAFT", "PAID"];

  return <Select name="status" items={items} {...props} />;
}
